<div class="p-1 text-xs max-md:border-t max-md:pt-3 border-grey-concrete text-pretty">
  Copyright &copy; {{ footerDate | date: 'yyyy' }} {{ companyName }}. All rights reserved.
</div>
<div
  id="cookie-bar"
  class="md:fixed mt-auto bottom-0 left-0 p-0 md:py-1 max-md:font-light font-normal md:border-t border-grey-concrete backdrop-blur-sm bg-white/50 w-full max-md:text-[.8em] text-balance"
>
  <span
    >We use cookies to enhance your browsing experience.
    <a class="btn-link text-primary" target="_blank" href="https://www.eset.com/za/privacy/">Read more</a></span
  >
</div>
